import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appBgOpacityScroll]'
})
export class BgOpacityScrollDirective {

  constructor(private el: ElementRef) {
    el.nativeElement.style.height = '100%';
    el.nativeElement.style.transition = 'background 100ms ease';
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(evt: any) {
   const currPos = (window.pageYOffset || evt.target.scrollTop) - (evt.target.clientTop || 0);
   this.update(currPos);
  }

  update(currPos: number): void {
    const opacity = currPos ?  Math.min(0.6, currPos * 0.001) : 0;

      requestAnimationFrame( args => {
        this.el.nativeElement.style.background = 'rgba(0,0,0,' + opacity + ')';
      });
  }
}
